import { homeForUser } from '../../services/workspacesApi';
import { TENANT } from '../../config';

/**
 * Where a person lands after signing in when nothing carried them elsewhere.
 * One answer for the password sign-in (AuthFlow) and the Microsoft landing
 * route, so the two can never send the same person to different homes.
 *
 * The server decides from ratified capability; if that lookup fails we fall
 * back to the older role-based behaviour rather than holding someone at the
 * door over a navigation question. eMerge: WorkspaceHome says "no workspace
 * yet" or offers a retry, rather than dropping a worker on an investor page.
 */
export async function defaultDestination(role?: string): Promise<string> {
  const home = await homeForUser();
  if (home) return home;
  if (TENANT.id === 'emerge') return '/home';
  return role === 'admin' ? '/admin/dashboard' : '/portal/invest/properties';
}
